import { render, staticRenderFns } from "./schedule-details.vue?vue&type=template&id=3905fbf8&scoped=true&"
import script from "./schedule-details.vue?vue&type=script&lang=js&"
export * from "./schedule-details.vue?vue&type=script&lang=js&"
import style0 from "./schedule-details.vue?vue&type=style&index=0&id=3905fbf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3905fbf8",
  null
  
)

export default component.exports